module.exports = __webpack_public_path__ + "static/img/ikona_cw5-ON.9781a489.png";